import { Link, useNavigate } from "react-router-dom";
import { fmt } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { toast } from "sonner";

export const ProductCard = ({ product }) => {
  const hasSwap = Boolean(product.image2);
  const { isWishlisted, toggleWishlist } = useAuth();
  const nav = useNavigate();
  const saved = isWishlisted(product.id);

  const onHeart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const res = await toggleWishlist(product.id);
    if (res === "unauth") { toast("Log in to save to your wishlist"); nav("/login"); }
    else if (res === "ok") toast(saved ? "Removed from wishlist" : "Saved to wishlist");
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link to={`/product/${product.slug}`} data-testid={`product-card-${product.slug}`} className="group block">
        <div className="relative w-full aspect-[4/5] bg-card overflow-hidden">
          <img src={product.image} alt={product.name} className="absolute inset-0 w-full h-full object-cover"
            style={hasSwap ? { transition: "opacity 500ms ease" } : undefined} />
          {hasSwap && (
            <img src={product.image2} alt={product.name}
              className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100"
              style={{ transition: "opacity 500ms ease" }} />
          )}
          <button data-testid={`wishlist-${product.slug}`} onClick={onHeart}
            className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center link-hover">
            <Heart className="w-[18px] h-[18px] text-black" strokeWidth={1.5} fill={saved ? "#000" : "none"} />
          </button>
        </div>
        <div className="pt-3">
          <h3 className="product-title text-[13px]">{product.name}</h3>
          <p className="caption text-[12px] mt-1">{product.material}</p>
          <p className="text-[13px] mt-1">{fmt(product.price)}</p>
        </div>
      </Link>
    </motion.div>
  );
};
